import { c as _c } from "react/compiler-runtime";
import { Icon } from '@udemy-v2/icons';
import { IconButton } from '@udemy-v2/react-core-components';
import classNames from 'classnames';
import React, { MouseEvent, useState } from 'react';
import { ReviewFeedbackSubmitEvent, ReviewFeedbackClearEvent } from '../../../../events/events';
import { useHelpfulness } from '../../hooks/use-helpfulness';
import styles from './review-feedback.module.scss';
import { useI18n } from '@udemy-v2/i18n';
import { publishEvent } from '@udemy-v2/event-tracking';
interface ReviewFeedbackProps {
  reviewId: number;
  frontendTrackingId?: string;
  reviewableObjectId: number;
  reviewableObjectType: string;
  isFeaturedReview?: boolean;
  reviewAuthorName: string;
}
export const ReviewFeedback = t0 => {
  const $ = _c(51);
  const {
    reviewId,
    frontendTrackingId,
    reviewableObjectId,
    reviewableObjectType,
    isFeaturedReview: t1,
    reviewAuthorName
  } = t0;
  const isFeaturedReview = t1 === undefined ? false : t1;
  const [statusMessage, setStatusMessage] = useState("");
  const {
    gettext,
    interpolate
  } = useI18n();
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      rating: null,
      term: null
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== reviewId || $[2] !== reviewableObjectId) {
    t3 = {
      reviewId,
      courseId: reviewableObjectId,
      viewPosition: 1,
      page: 1,
      filterState: t2
    };
    $[1] = reviewId;
    $[2] = reviewableObjectId;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    value: helpfulnessValue,
    onToggle: onHelpfulnessToggle
  } = useHelpfulness(t3);
  let t4;
  if ($[4] !== frontendTrackingId || $[5] !== gettext || $[6] !== helpfulnessValue || $[7] !== interpolate || $[8] !== isFeaturedReview || $[9] !== onHelpfulnessToggle || $[10] !== reviewAuthorName || $[11] !== reviewId || $[12] !== reviewableObjectId || $[13] !== reviewableObjectType) {
    t4 = e => {
      const {
        value: feedbackButtonValue
      } = e.currentTarget as HTMLButtonElement;
      const feedbackHelpfulness = feedbackButtonValue === "yes";
      if (frontendTrackingId) {
        if (feedbackButtonValue === "yes" && helpfulnessValue === true || feedbackButtonValue === "no" && helpfulnessValue === false) {
          publishEvent(new ReviewFeedbackClearEvent({
            courseTrackingId: frontendTrackingId,
            reviewId,
            isFeatured: isFeaturedReview,
            wasHelpful: feedbackHelpfulness,
            reviewableObjectId,
            reviewableObjectType
          }));
          setStatusMessage(interpolate(gettext("Removed feedback for review by %(name)s as %(feedback)s"), {
            name: reviewAuthorName,
            feedback: feedbackHelpfulness ? gettext("Helpful") : gettext("Unhelpful")
          }, true));
        } else {
          publishEvent(new ReviewFeedbackSubmitEvent({
            courseTrackingId: frontendTrackingId,
            reviewId,
            isFeatured: isFeaturedReview,
            isHelpful: feedbackHelpfulness,
            reviewableObjectId,
            reviewableObjectType
          }));
          setStatusMessage(interpolate(gettext("%(feedback)s"), {
            feedback: feedbackHelpfulness ? gettext("Helpful") : gettext("Unhelpful")
          }, true));
        }
      }
      onHelpfulnessToggle(feedbackHelpfulness);
    };
    $[4] = frontendTrackingId;
    $[5] = gettext;
    $[6] = helpfulnessValue;
    $[7] = interpolate;
    $[8] = isFeaturedReview;
    $[9] = onHelpfulnessToggle;
    $[10] = reviewAuthorName;
    $[11] = reviewId;
    $[12] = reviewableObjectId;
    $[13] = reviewableObjectType;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  const handleFeedbackClick = t4;
  const thumbupicon = helpfulnessValue === true ? "thumb-up-filled" : "thumb-up";
  const thumbdownicon = helpfulnessValue === false ? "thumb-down-filled" : "thumb-down";
  let t5;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = classNames("ud-text-xs", styles["feedback-label"]);
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== gettext) {
    t6 = gettext("Helpful?");
    $[16] = gettext;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t6) {
    t7 = <span className={t5}>{t6}</span>;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== gettext || $[21] !== helpfulnessValue || $[22] !== interpolate || $[23] !== reviewAuthorName) {
    t8 = helpfulnessValue === true ? interpolate(gettext("Undo mark review by %(name)s as helpful"), {
      name: reviewAuthorName
    }, true) : interpolate(gettext("Mark review by %(name)s as helpful"), {
      name: reviewAuthorName
    }, true);
    $[20] = gettext;
    $[21] = helpfulnessValue;
    $[22] = interpolate;
    $[23] = reviewAuthorName;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== t8 || $[26] !== thumbupicon) {
    t9 = <Icon glyph={thumbupicon} label={t8} color="neutral" size="small" />;
    $[25] = t8;
    $[26] = thumbupicon;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== handleFeedbackClick || $[29] !== t9) {
    t10 = <IconButton size="small" udStyle="ghost" onClick={handleFeedbackClick} value="yes">{t9}</IconButton>;
    $[28] = handleFeedbackClick;
    $[29] = t9;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  let t11;
  if ($[31] !== gettext || $[32] !== helpfulnessValue || $[33] !== interpolate || $[34] !== reviewAuthorName) {
    t11 = helpfulnessValue === false ? interpolate(gettext("Undo mark review by %(name)s as unhelpful"), {
      name: reviewAuthorName
    }, true) : interpolate(gettext("Mark review by %(name)s as unhelpful"), {
      name: reviewAuthorName
    }, true);
    $[31] = gettext;
    $[32] = helpfulnessValue;
    $[33] = interpolate;
    $[34] = reviewAuthorName;
    $[35] = t11;
  } else {
    t11 = $[35];
  }
  let t12;
  if ($[36] !== t11 || $[37] !== thumbdownicon) {
    t12 = <Icon glyph={thumbdownicon} label={t11} color="neutral" size="small" />;
    $[36] = t11;
    $[37] = thumbdownicon;
    $[38] = t12;
  } else {
    t12 = $[38];
  }
  let t13;
  if ($[39] !== handleFeedbackClick || $[40] !== t12) {
    t13 = <IconButton size="small" udStyle="ghost" onClick={handleFeedbackClick} value="no">{t12}</IconButton>;
    $[39] = handleFeedbackClick;
    $[40] = t12;
    $[41] = t13;
  } else {
    t13 = $[41];
  }
  let t14;
  if ($[42] !== t10 || $[43] !== t13) {
    t14 = <div className={styles["feedback-actions"]}>{t10}{t13}</div>;
    $[42] = t10;
    $[43] = t13;
    $[44] = t14;
  } else {
    t14 = $[44];
  }
  let t15;
  if ($[45] !== statusMessage) {
    t15 = <div role="status" aria-live="polite" aria-atomic="true" className="ud-sr-only">{statusMessage}</div>;
    $[45] = statusMessage;
    $[46] = t15;
  } else {
    t15 = $[46];
  }
  let t16;
  if ($[47] !== t14 || $[48] !== t15 || $[49] !== t7) {
    t16 = <div className={styles["feedback-container"]}>{t7}{t14}{t15}</div>;
    $[47] = t14;
    $[48] = t15;
    $[49] = t7;
    $[50] = t16;
  } else {
    t16 = $[50];
  }
  return t16;
};